import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import Dialog from "../../../../components/Dialog";
import { IModalGenerateTach } from "../../Modal/Actions/ModalGenerateTach";
import InputTextArea from "../../../../components/InputTextArea";
import InputTextAreaStyles from "../../../../styles/components/InputTextAreaStyles";
import { StyledTitle } from "../../../../styles/pages/AdministratorTach/ModalInformation";
import { StyledCenterDiv } from "../../../../styles/MainStyles";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import AdminTachService from "../../../../service/Docente/AdminTachService";
import GenericUtils from "../../../../utils/GenericUtils";
import DialogMessageProps from "../../../../model/DialogMessageProps";
import DialogMessage from "../../../../components/DialogMessage";
import { TypeDialogMessageEnum } from "../../../../model/Enums/TypeDialogMessageEnum";
import { useAdministratorTach } from "../../../../context/AdministratorTachContext";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";

const { StyledLabel } = InputTextAreaStyles;
const { BtnPrimary, DefaultButtonLink } = ButtonStyles;

interface IModalCancelContainer extends IModalGenerateTach {
    subprocessId: string;
}

const ModalCancelContainer: React.FC<IModalCancelContainer> = ({
    isOpen,
    onHide,
    subprocessId,
}) => {
    const [justification, setJustification] = useState("");
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const placeholder =
        "Insira sua justificativa com até 500 caracteres para cancelar seu TACH";

    const { instance } = useMsal();
    const { pagination, getSubprocessos } = useAdministratorTach();
    const { filterPage } = useFilterData();

    const handleCloseDialogMessage = () => {
        if (dialogMessageProps.type === TypeDialogMessageEnum.Success) {
            onHide();
            getSubprocessos(filterPage, pagination);
        }

        setDialogMessageProps({} as DialogMessageProps);
    };

    const handleSubmit = async () => {
        const response = await AdminTachService.cancelSubprocessById(
            subprocessId,
            justification,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "TACH cancelado com sucesso",
            });
        } else {
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={handleCloseDialogMessage}
        />
    );

    return (
        <>
            <Dialog
                openModal={isOpen}
                onHide={() => onHide()}
                size="width-600 modal-radius-8"
            >
                <StyledTitle>Cancelar TACH</StyledTitle>
                <StyledLabel htmlFor="justifyTextbox">
                    Justificativa
                </StyledLabel>
                <InputTextArea
                    id="justifyTextbox"
                    value={justification}
                    onChange={(event: any) =>
                        setJustification(event.target.value as string)
                    }
                    maxLength={500}
                    placeholder={placeholder}
                    style={{ height: "90px" }}
                />
                <StyledCenterDiv>
                    <DefaultButtonLink onClick={() => onHide()}>
                        Fechar
                    </DefaultButtonLink>
                    <BtnPrimary
                        onClick={() => {
                            handleSubmit();
                        }}
                        disabled={!justification.length}
                    >
                        Confirmar
                    </BtnPrimary>
                </StyledCenterDiv>
            </Dialog>
            {dialogMessage}
        </>
    );
};

export default ModalCancelContainer;
